<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import { Account } from '../types';
import repository from './account-repository';

interface Data {
  task: Promise<Account>|undefined,
}

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  mixins: [HasTaskMixin],
  components: {
    Loader,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    modelValue: Object as () => Account,
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  watch: {
    accountId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.find(this.accountId);
      this.task.then((account) => {
        this.$emit('update:modelValue', account);
        this.$emit('loaded', account);
      });
    },
  },
});
</script>
